import { Component, OnInit } from '@angular/core';
import { faLightbulb } from '@fortawesome/free-solid-svg-icons';
import { Store } from '@ngrx/store';
import * as fromCoursePlayer from '../course-player.reducer';
import * as actions from '../course-player.actions';
import { MixpanelService } from '@app/_services/mixpanel.service';

@Component({
  selector: 'app-tips',
  templateUrl: './tips.component.html'
})
export class TipsComponent implements OnInit {

  faLightbulb = faLightbulb;

  constructor(private store: Store<{ coursePlayerState: fromCoursePlayer.State }>,
    private mixpanel: MixpanelService) { 

  }

  ngOnInit(): void {
  }

  showTips() {
    this.mixpanel.track('Course Player - Tips Button');
    this.store.dispatch(new actions.ShowTips());
  }
}
